import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dashcase' })
export class DashCasePipe implements PipeTransform {
  transform(str: string, args?: any) : string {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}